export default "__VITE_ASSET__CASaecBO__"